import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("bvg_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

api.interceptors.response.use(
    (r) => r,
    (err) => {
        if (err?.response?.status === 401) {
            const isAuthMe = err?.config?.url?.includes("/auth/me");
            if (!isAuthMe && localStorage.getItem("bvg_token")) {
                localStorage.removeItem("bvg_token");
                localStorage.removeItem("bvg_user");
                if (window.location.pathname !== "/login") {
                    window.location.href = "/login";
                }
            }
        }
        return Promise.reject(err);
    }
);

export const errorMessage = (err) => {
    const d = err?.response?.data?.detail;
    if (!d) return err?.message || "Terjadi kesalahan";
    if (typeof d === "string") return d;
    if (Array.isArray(d)) return d.map((e) => e.msg || JSON.stringify(e)).join(" ");
    return typeof d === "object" && d.msg ? d.msg : JSON.stringify(d);
};

export default api;
